/*
 * Fonte ÚNICA da verdade da marca deste widget (regra: 1 widget = 1 marca).
 *
 * Definida em tempo de build via env `REACT_APP_WIDGET_BRAND`. Para gerar o
 * widget de outra marca (ex.: Betpix), basta trocar esse valor no deploy —
 * nada de marca hardcoded espalhado pelo código.
 *
 * Obs.: o prefixo é `REACT_APP_*` e NÃO `VITE_*` — herança do CRA, mantida de propósito na
 * migração (o `define` do `vite.config.ts` a reproduz), porque é o que os painéis do Cloudflare
 * Pages das duas marcas já têm configurado. Trocar exigiria mexer nos dois painéis, num deploy que
 * vai direto pro apostador. Só vars com esse prefixo chegam ao bundle.
 */
export const WIDGET_BRAND = (process.env.REACT_APP_WIDGET_BRAND || "vaidebet").trim().toLowerCase();
